import { createStorageAtomFactory } from '@exodus/atoms';
import type { Definition } from '@exodus/dependency-types';

import type { Storage } from '@/background/adapters/storage';
import { getMobileOS, isInstalled } from '@/ui/utils/navigator';

type Dependencies = {
  storage: Storage;
};

const createInstallModalVisibleAtom = ({ storage }: Dependencies) => {
  const createAtom = createStorageAtomFactory<boolean>({ storage });

  return createAtom({
    key: 'installModalVisible',
    defaultValue:
      __STANDALONE_MODE__ && Boolean(getMobileOS()) && !isInstalled(),
  });
};

export type InstallModalVisibleAtom = ReturnType<
  typeof createInstallModalVisibleAtom
>;

const installModalVisibleAtomDefinition = {
  id: 'installModalVisibleAtom',
  type: 'atom',
  factory: createInstallModalVisibleAtom,
  dependencies: ['storage'],
} as const satisfies Definition;

export default installModalVisibleAtomDefinition;
